export default __webpack_public_path__ + "static/media/married.e8cd5088.jpg";